import { createSlice } from "@reduxjs/toolkit";

const initialState = { driverUnReviewedCount: 0, isSidebarCollapsed: true, helpDeskUnreadCount: 0 };

const uiSlice = createSlice({
  name: "uiSlice",
  initialState,
  reducers: {
    setCount: (state, action) => {
      state.driverUnReviewedCount = action.payload;
    },
    decrementCount: (state) => {
      state.driverUnReviewedCount -= 1;
    },
    toggleSidebar: (state) => {
      state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
    setHelpDeskCount: (state, action) => {
      state.helpDeskUnreadCount = action.payload;
    },
    decrementHelpDeskCount: (state) => {
      state.helpDeskUnreadCount -= 1;
    },
  },
});

export const { setCount, decrementCount, toggleSidebar, setHelpDeskCount, decrementHelpDeskCount } = uiSlice.actions;

export default uiSlice.reducer;
